

(function($){
  // Normalize for case/diacritic-insensitive match
  function norm(s){
    return String(s || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  // Safely find the related input value before/around the swatch
  function getSwatchValue($swatch){
    const directPrev = $swatch.prev('input').val();
    if (directPrev) return directPrev;

    const inside = $swatch.find('input').val();
    if (inside) return inside;

    const inLabel = $swatch.closest('label').find('input').val();
    if (inLabel) return inLabel;

    const inParent = $swatch.parent().find('input').first().val();
    return inParent || '';
  }

  $(document).on('click', '.color-swatch', function(){
    const $swatch = $(this);
    const valRaw = getSwatchValue($swatch);
    if (!valRaw) return;

    const value = norm(valRaw);

    const $scope = $swatch.closest('.grid-product__content');
    if (!$scope.length) return;

    // Get the Swiper container and instance
    const container = $scope.find('.swiper, .swiper-container').get(0);
    if (!container || !container.swiper) {
      console.warn('Swiper container not found or not initialized');
      return;
    }
    const swiper = container.swiper;

    // Find matching slide by data-color-name (case/diacritic-insensitive)
    const $slides = $scope.find('.swiper-slide');
    const targetIndex = $slides.toArray().findIndex(slide => {
      const name = $(slide).data('colorName'); // reads data-color-name
      return norm(name) === value;
    });

    if (targetIndex < 0) {
      console.warn('No matching slide for color:', valRaw);
      return;
    }

    swiper.slideTo(targetIndex, 300);
  });



  setTimeout(() => {
    // IDs of elements you want to move
    const elementClasses = ['.advertorial-what', '.advertorial-how', '.advertorial-benefits', '.advertorial-steps'];

    // Create wrapper and append to body

    // const left_wrapper = document.createElement('div');
    // left_wrapper.id = 'advertorial-left-side';

    // const righ_wrapper = document.createElement('div');
    // left_wrapper.id = 'advertorial-righ-side';

    // document.querySelector("#advertorial-wrapper").appendChild(left_wrapper);

    // Move elements into wrapper
    elementClasses.forEach(cl => {
      const el = document.querySelector(cl);
      if (el) document.querySelector("#advertorial-left-side").appendChild(el);
    });


    document.querySelector("#advertorial-right-side").appendChild(document.querySelector(".vk-review-carousel"));
    document.querySelector("#advertorial-wrapper").appendChild(document.querySelector("#advertorial-right-side"));
    document.querySelector("#empty-placeholder").remove();
  }, 500);
  


})(jQuery);